import React, { useEffect, useState, useContext } from 'react'
import Select from '../../components/Select'
import Modal from 'react-bootstrap/Modal';
import InputFilterManager from '../InputFilterManager'
import api from '../../services/api'


import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import InputSelectFilterManager from '../InputSelectFilterManager';
import { CountagesContext } from '../../context/countages';
import { ClientContext } from '../../context/client'
import { ModalContext } from '../../context/modal';
import fileIcon from '../../images/svg/fileIcon.svg';
import closeIcon from '../../images/svg/closeIcon.svg';
import trash from '../../images/svg/trash.svg'
import trashActive from '../../images/svg/trashActive.svg'
import { read, utils } from 'xlsx'
import SelectType from '../SelectType';
import FilterModal from '../FilterModal';
import { useTranslation } from 'react-i18next';


const FilterManager = () => {
    const { t } = useTranslation()

    const [showModal, setShowModal] = useState(false)
    const [showModalUpload, setShowModalUpload] = useState(false)
    const [list, setList] = useState([{ idCountage: 1 }])

    const [listData, setListData] = useState([])
    const [number, setNumber] = useState(1)
    const [numberListData, setNumberListData] = useState(1)

    const [sucess, setSucess] = useState(false)
    const [stock, setStock] = useState([])
    const [typeCountage, setTypeCountage] = useState()

    const [client, setClient] = useState()
    const [fileCvg, setFileCvg] = useState()
    const [selectTypeCount, setSelectTypeCount] = useState("")

    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [numberLine, setNumberLine] = useState(0);

    /* BTN STATE */

    const [stateBtn, setStateBtn] = useState(true)
    const [filterModalState, setFilterModalState] = useState(false)


    /* ERROR MESSAGES */
    const [clientError, setClientError] = useState()
    const [typeCountageError, setTypeCountageError] = useState()
    const [newName, setNewName] = useState()


    /* CLIENT CONTEXT */
    const {
        getClient,
        getTypeCountage,
        setTypeGet,
        clientType,
        setClientType,
        getTypeCountageLocation,
        totalCounts,
        deleteSelect,
        setDeleteSelect,
        idsDelete
    } = useContext(ClientContext)

    /* COUNT CONTEXT */
    const { getByName } = useContext(CountagesContext)

    /* MODAL CONTEXT */

    const setItems = () => {

        const items = [...list]

        items.push({ idCountage: items.length + 1 })
        setList(items)



    }

    const getItems = async (e) => {

        getByName(e)


    }

    const setItemsData = (value) => {


        const itemExists = listData.findIndex(item => item.data == value)

        if (itemExists == -1) {

            setNumberListData(number + 1)
            const items = listData
            items.push({ idCountage: numberListData, data: value })
            setListData(items)
        }

        console.log(listData)


    }

    const removeItem = async (id, name) => {
        /* REMOVE ITEM LIST */
        const array = list.slice()
        array.splice(list.indexOf(id), 1)
        setList(array)
        setNumber(number - 1)

        const response = await api.delete(`reason/${name}`)

        console.log(response.data)

        /* REMOVE ITEM LISTDATA */


        const index = listData.findIndex((item) => item.id == id)
        listData.splice(index, 1)

        setNumber(number - 1)


    }

    const storage = async () => {
        setSucess(true)

        listData.map(async item => {

            if (String(item.data).length > 0) {

                const response = await api.post("reason", {

                    "reason": item.data,
                    "mail": localStorage.getItem("@USER_MAIL")

                })


                if (response.status == 200) {

                    // setSucess(true)

                }

            }
        })

    }

    const handleFile = async (file) => {

        if (file.type != "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {

            toast.error("Formato de arquivo inválido!", {
                autoClose: 2000,
            })
            return false
        }

        const data = await file.arrayBuffer()

        const workbook = read(data)


        const workSheet = workbook.Sheets[workbook.SheetNames[0]]
        const worksheet = utils.sheet_to_json(workSheet);

        setFileCvg(file)
        setStock(worksheet)

        setNumberLine(worksheet.length)


    }

    const formatDate = (date) => {
        const data = new Date(0);

        data.setUTCSeconds(Number(date) * 86400);

        const day = data.getUTCDate();
        const month = data.getUTCMonth() + 1; // Add +1 because months are zero-indexed
        const year = data.getUTCFullYear();

        // Formatting date components
        const formattedDay = day < 10 ? "0" + day : day;
        const formattedMonth = month < 10 ? "0" + month : month;

        const formattedDate = formattedDay + "/" + formattedMonth + "/" + year;

        return formattedDate;
    }

    const storageTest = async () => {
        let exist = false

        if (client == undefined) {

            setClientError("informe um cliente")
            return false
        }
        if (typeCountage == undefined) {

            setTypeCountageError("informe uma contagem")
            return false
        }

        if (client == undefined || typeCountage == undefined) {
            return false
        }

        if (!stock) {
            return toast.error('Insira um arquivo excel', {
                position: "top-right",
                autoClose: "1000",
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }

        setStateBtn(false)

        try {

            for (const item of stock) {
                let formattedValidateDate = item['Validade'] ? formatDate(item['Validade']) : null;
                let formattedManufactureDate = item.Fabricacao ? formatDate(item.Fabricacao) : null;

                try {
                    const stock2 = await api.post("countage/verify/count/exist", {
                        "typeCount": typeCountage,
                        "client": client,
                        "deposit": item['Deposito'],
                        "product": item['Código de barras'],
                        "description": item['Descrição'],
                        "productCode": item['Código do Produto'],
                        "batch": item['Lote'],
                        "series": item['Series'],
                        "validate": formattedValidateDate,
                        "temperature": item['Temperatura'],
                        "address": item['Endereco'],
                        "typeStructure": item['Estrutura'],
                        "manufacture": formattedManufactureDate,
                        "typeStructure": item.Estrutura,
                        "address": item.Endereco,
                        "temperature": item.Temperatura,
                        "unitaryValue": item['ValorUnitario'],
                        "initialValue": item['QtdInicial'],
                        "location": item['Local ou Filial']
                    });

                    if (stock2.status == 400) {
                        toast.error('O arquivo já foi carregado anteriormente. Por favor, exclua o arquivo existente antes de fazer o upload de um novo.', {
                            position: "top-right",
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        });
                        exist = true

                        setTimeout(() => {
                            window.location.href = "/dashboard/manager";
                        }, 5000);

                        break
                    }
                } catch (error) {


                }
            }

            if (!exist) {

                toast.loading('Enviando dados...', {
                    position: "top-right",
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });

                for (const item of stock) {
                    try {
                        let formattedValidateDate = item['Validade'] ? formatDate(item['Validade']) : null;
                        let formattedManufactureDate = item.Fabricacao ? formatDate(item.Fabricacao) : null;
                        const existAddress = await api.get(`countage/by/address/${item['Endereco']}`);

                        const stock2 = await api.post("countage", {
                            "typeCount": typeCountage,
                            "client": client,
                            "deposit": item['Deposito'],
                            "product": item['Código de barras'],
                            "description": item['Descrição'],
                            "productCode": item['Código do Produto'],
                            "batch": item['Lote'],
                            "series": item['Series'],
                            "validate": formattedValidateDate,
                            "temperature": item['Temperatura'],
                            "address": item['Endereco'],
                            "typeStructure": item['Estrutura'],
                            "manufacture": formattedManufactureDate,
                            "typeStructure": item.Estrutura,
                            "address": item.Endereco,
                            "temperature": item.Temperatura,
                            "unitaryValue": item['ValorUnitario'],
                            "initialValue": item['QtdInicial'],
                            "location": item['Local ou Filial']
                        });

                        const emailArray = String(item['Email']).split(",");

                        if (emailArray.length > 0) {
                            for (const mail of emailArray) {
                                const response = mail && await api.get(`/user/by/mail/${mail}`);
                                if (response.status == 200) {
                                    if (stock2?.data?.id) {
                                        await api.post("user/countage", {
                                            "name": response.data.name,
                                            "client": client,
                                            "mail": response.data.mail,
                                            "id_countage": stock2.data.id
                                        });
                                    }
                                }
                            }
                        }
                    } catch (error) {
                        console.log(error);
                    }
                }
            }

            setTimeout(() => {
                window.location.href = "/dashboard/manager";
            }, 5000);


        } catch (error) {

            toast.error('Ops.. algo deu errado!', {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }

    }

    const getItemsDatabase = async () => {

        const response = await api.get("reason")
        const array = []
        response.data.map((currElement, index) => {

            setNumber(number + 1)
            array.push({ reason: currElement.reason, idCountage: index + 1 })

        })


        setList(array)


    }

    const deleteAllCount = async () => {
        toast.loading('Deletando contagens...', {
            position: "top-right",
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
        });

        for (const item of idsDelete) {
            api.delete(`countage/${item}`)
        }
        setTimeout(() => {
            window.location.reload()
        }, 2000);
    }

    const inputPrimary = {

        border: "1px solid #D7D7D7",
        width: "300px",
        height: "45px",
        borderRadius: "60px",
        outline: "none",
        paddingLeft: "50px",

    }

    const btnStyle = {

        border: "none",
        outline: "none",
        background: deleteSelect ? "#FFE1E1" : "#123164",
        borderRadius: "60px",
        color: deleteSelect ? "#EA0000" : "#fff",
        width: "176px",
        height: "45px",
    }

    const btnStyleModal = {
        cursor: stateBtn == true ? "pointer" : "not-allowed",
        border: "none",
        outline: "none",
        background: "#123164",
        borderRadius: "50px",
        width: "101px",
        height: "36px",
    }

    useEffect(() => {

        if (sucess == true) {

            toast.success('Dados adicionados com sucesso!', {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });

            setTimeout(() => {

                setSucess(false)
                window.location.href = "/dashboard/manager"


            }, [3000])

        }

    }, [sucess])

    useEffect(() => {

        if (client != undefined) {
            setClientError()
        }
        if (typeCountage != undefined) {
            setTypeCountageError()
        }


    }, [client, typeCountage])

    useEffect(() => {
        getItemsDatabase()
    }, [])


    return (

        <div style={{ marginBottom: "20px", marginTop: "2.06rem" }}>
            <ToastContainer />

            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>

                <div style={{ display: "flex" }}>

                    <div style={{ position: "relative", marginRight: "17px" }}>
                        <input className="textInputPrimaryFilter" onChange={(e) => getItems(e.target.value)} placeholder={t('search')} style={inputPrimary} />

                        <div style={{ position: "absolute", top: "7px", left: "13px" }}>
                            <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M9 0C13.968 0 18 4.032 18 9C18 13.968 13.968 18 9 18C4.032 18 0 13.968 0 9C0 4.032 4.032 0 9 0ZM9 16C12.867 16 16 12.867 16 9C16 5.132 12.867 2 9 2C5.132 2 2 5.132 2 9C2 12.867 5.132 16 9 16ZM17.485 16.071L20.314 18.899L18.899 20.314L16.071 17.485L17.485 16.071Z" fill="#123164" />
                            </svg>
                        </div>

                    </div>

                    <div style={{
                        display: "flex",
                        gap: "17px"
                    }}>

                        <div style={{ cursor: "pointer" }} onClick={() => setShowModal(true)}>
                            <svg width="45" height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="0.5" y="0.5" width="44" height="44" rx="11.5" fill="white" />
                                <path d="M23 25C24.6569 25 26 23.6569 26 22C26 20.3431 24.6569 19 23 19C21.3431 19 20 20.3431 20 22C20 23.6569 21.3431 25 23 25Z" stroke="#123164" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M13 22.88V21.12C13 20.08 13.85 19.22 14.9 19.22C16.71 19.22 17.45 17.94 16.54 16.37C16.02 15.47 16.33 14.3 17.24 13.78L18.97 12.79C19.76 12.32 20.78 12.6 21.25 13.39L21.36 13.58C22.26 15.15 23.74 15.15 24.65 13.58L24.76 13.39C25.23 12.6 26.25 12.32 27.04 12.79L28.77 13.78C29.68 14.3 29.99 15.47 29.47 16.37C28.56 17.94 29.3 19.22 31.11 19.22C32.15 19.22 33.01 20.07 33.01 21.12V22.88C33.01 23.92 32.16 24.78 31.11 24.78C29.3 24.78 28.56 26.06 29.47 27.63C29.99 28.54 29.68 29.7 28.77 30.22L27.04 31.21C26.25 31.68 25.23 31.4 24.76 30.61L24.65 30.42C23.75 28.85 22.27 28.85 21.36 30.42L21.25 30.61C20.78 31.4 19.76 31.68 18.97 31.21L17.24 30.22C16.33 29.7 16.02 28.53 16.54 27.63C17.45 26.06 16.71 24.78 14.9 24.78C13.85 24.78 13 23.92 13 22.88Z" stroke="#123164" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                <rect x="0.5" y="0.5" width="44" height="44" rx="11.5" stroke="#D7D7D7" />
                            </svg>
                        </div>

                        <div style={{ cursor: "pointer" }} onClick={() => setShowModalUpload(true)}>
                            <svg width="45" height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="0.5" y="0.5" width="44" height="44" rx="11.5" fill="white" />
                                <path d="M26.1642 23.5033L24.3583 25.6667L26.1642 27.83C26.485 28.215 26.4392 28.7925 26.045 29.1225C25.8708 29.2692 25.6692 29.3333 25.4583 29.3333C25.1925 29.3333 24.9358 29.2233 24.7525 29.0033L23.1667 27.0967L21.5808 29.0033C21.3975 29.2233 21.1408 29.3333 20.875 29.3333C20.6642 29.3333 20.4625 29.26 20.2883 29.1225C19.9033 28.8017 19.8483 28.2242 20.1692 27.83L21.975 25.6667L20.1692 23.5033C19.8483 23.1183 19.8942 22.5408 20.2883 22.2108C20.6825 21.89 21.2508 21.9358 21.5808 22.33L23.1667 24.2367L24.7525 22.33C25.0733 21.945 25.6508 21.89 26.045 22.2108C26.43 22.5317 26.485 23.1092 26.1642 23.5033ZM32.3333 20.6158V28.4167C32.3333 30.9467 30.28 33 27.75 33H18.5833C16.0533 33 14 30.9467 14 28.4167V15.5833C14 13.0533 16.0533 11 18.5833 11H22.7175C24.4317 11 26.045 11.6692 27.255 12.8792L30.445 16.0783C31.655 17.2883 32.3242 18.9017 32.3242 20.6158H32.3333ZM25.9625 14.1717C25.6692 13.8783 25.3483 13.6308 25 13.4292V17.4167C25 17.9208 25.4125 18.3333 25.9167 18.3333H29.895C29.6933 17.985 29.4458 17.6642 29.1525 17.3708L25.9625 14.1717ZM30.5 20.6067C30.5 20.46 30.5 20.3042 30.4817 20.1575H25.9167C24.4042 20.1575 23.1667 18.92 23.1667 17.4075V12.8517C23.02 12.8333 22.8733 12.8333 22.7175 12.8333H18.5833C17.0708 12.8333 15.8333 14.0708 15.8333 15.5833V28.4167C15.8333 29.9292 17.0708 31.1667 18.5833 31.1667H27.75C29.2625 31.1667 30.5 29.9292 30.5 28.4167V20.6158V20.6067Z" fill="#123164" />
                                <rect x="0.5" y="0.5" width="44" height="44" rx="11.5" stroke="#D7D7D7" />
                            </svg>
                        </div>

                        <div style={{ cursor: "pointer", position: "relative" }}>
                            <div onClick={() => setFilterModalState(!filterModalState)}>
                                <svg width="45" height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="0.5" y="0.5" width="44" height="44" rx="11.5" fill="white" />
                                    <path d="M24.9144 33C24.7161 33 24.5231 32.9357 24.3644 32.8167L20.6977 30.0667C20.5839 29.9813 20.4915 29.8706 20.4279 29.7433C20.3642 29.616 20.3311 29.4756 20.3311 29.3333V24.1817L13.8997 16.9464C13.443 16.4311 13.1448 15.7949 13.0409 15.1142C12.937 14.4335 13.032 13.7373 13.3143 13.1093C13.5966 12.4812 14.0543 11.9481 14.6323 11.5739C15.2104 11.1997 15.8842 11.0004 16.5727 11H29.5894C30.2779 11.0008 30.9516 11.2004 31.5294 11.5748C32.1072 11.9493 32.5646 12.4826 32.8466 13.1107C33.1286 13.7388 33.2232 14.435 33.1191 15.1156C33.015 15.7962 32.7166 16.4323 32.2597 16.9473L25.8311 24.1817V32.0833C25.8311 32.3264 25.7345 32.5596 25.5626 32.7315C25.3907 32.9034 25.1575 33 24.9144 33ZM22.1644 28.875L23.9977 30.25V23.8333C23.9979 23.6089 24.0804 23.3923 24.2297 23.2247L30.892 15.7291C31.1141 15.478 31.2591 15.1681 31.3095 14.8367C31.3598 14.5052 31.3135 14.1663 31.1759 13.8605C31.0384 13.5548 30.8156 13.2952 30.5341 13.113C30.2527 12.9308 29.9247 12.8337 29.5894 12.8333H16.5727C16.2377 12.8338 15.9098 12.931 15.6286 13.1132C15.3473 13.2953 15.1246 13.5547 14.9871 13.8603C14.8496 14.1659 14.8032 14.5047 14.8534 14.836C14.9036 15.1673 15.0483 15.477 15.2702 15.7282L21.9334 23.2247C22.0823 23.3925 22.1645 23.609 22.1644 23.8333V28.875Z" fill="#123164" />
                                    <rect x="0.5" y="0.5" width="44" height="44" rx="11.5" stroke="#D7D7D7" />
                                </svg>
                            </div>

                            {
                                filterModalState &&
                                <FilterModal />
                            }

                        </div>

                        <div style={{
                            border: "1px solid #d7d7d7",
                            borderRadius: "12px",
                            display: "flex",
                            alignItems: "center",
                            backgroundColor: "#fff",
                            padding: "10px",
                            gap: "10px"
                        }}>
                            <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M8.244 10.4917H14.3738C14.8572 10.4917 15.2495 10.8831 15.2495 11.3674C15.2495 11.8516 14.8572 12.2431 14.3738 12.2431H8.244C7.76061 12.2431 7.3683 11.8516 7.3683 11.3674C7.3683 10.8831 7.76061 10.4917 8.244 10.4917ZM7.3683 15.7458C7.3683 16.2301 7.76061 16.6215 8.244 16.6215H17.0009C17.4843 16.6215 17.8766 16.2301 17.8766 15.7458C17.8766 15.2616 17.4843 14.8701 17.0009 14.8701H8.244C7.76061 14.8701 7.3683 15.2616 7.3683 15.7458ZM8.244 7.8646H11.7468C12.2302 7.8646 12.6225 7.47317 12.6225 6.98891C12.6225 6.50465 12.2302 6.11321 11.7468 6.11321H8.244C7.76061 6.11321 7.3683 6.50465 7.3683 6.98891C7.3683 7.47317 7.76061 7.8646 8.244 7.8646ZM19.628 19.2486H8.244C7.76061 19.2486 7.3683 19.64 7.3683 20.1243C7.3683 20.6086 7.76061 21 8.244 21H19.628C20.1114 21 20.5037 20.6086 20.5037 20.1243C20.5037 19.64 20.1114 19.2486 19.628 19.2486ZM7.47514 2.86702L5.10463 0.496518C4.44349 -0.165506 3.28932 -0.165506 2.6273 0.496518L0.256797 2.86702C-0.085599 3.20942 -0.085599 3.76285 0.256797 4.10525C0.599193 4.44765 1.15263 4.44765 1.49503 4.10525L2.98984 2.61044V20.1243C2.98984 20.6086 3.38215 21 3.86553 21C4.34891 21 4.74122 20.6086 4.74122 20.1243V2.61044L6.23691 4.10525C6.40767 4.27601 6.63184 4.36183 6.85602 4.36183C7.0802 4.36183 7.30438 4.27601 7.47514 4.10525C7.81753 3.76285 7.81753 3.20942 7.47514 2.86702Z" fill="#123164" />
                            </svg>

                            <p className='textNumberLines'>{t('numberOfLines')}: {totalCounts}</p>


                        </div>

                        <div onClick={() => setDeleteSelect(!deleteSelect)} style={{ cursor: "pointer" }}>
                            <img src={deleteSelect ? trashActive : trash} />
                        </div>
                    </div>

                </div>



                <button className='textBtnFilterManager' onClick={() => {
                    deleteSelect ?
                        deleteAllCount()
                        :
                        window.location.href = "/dashboard/add/stock"

                }} style={btnStyle}>{deleteSelect ? t('destroyLine') : t('newItems') }</button>


                <Modal
                    dialogClassName="modal-filter-manager"
                    show={showModal}
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                >
                    <Modal.Header >

                        <div style={{ display: "flex", height: "30px" }}>
                            <div onClick={() => setShowModal(false)} style={{ cursor: "pointer" }}>
                                <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g clip-path="url(#clip0_0_2887)">
                                        <path d="M7.49864 6.3679L12.5016 1.35941C12.8122 1.04847 12.8122 0.544354 12.5016 0.233445C12.1911 -0.0774893 11.6876 -0.0774893 11.377 0.233445L6.37456 5.24246L1.37211 0.233445C1.06155 -0.0774893 0.55804 -0.0774893 0.247506 0.233445C-0.0630274 0.544378 -0.0630522 1.0485 0.247506 1.35941L5.25048 6.3679L0.247506 11.3764C-0.0630522 11.6874 -0.0630522 12.1915 0.247506 12.5024C0.558065 12.8133 1.06158 12.8133 1.37211 12.5024L6.37456 7.49334L11.377 12.5024C11.6876 12.8133 12.1911 12.8133 12.5016 12.5024C12.8122 12.1915 12.8122 11.6873 12.5016 11.3764L7.49864 6.3679Z" fill="black" />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_0_2887">
                                            <rect width="12.72" height="12.7354" fill="white" transform="translate(0.0143433)" />
                                        </clipPath>
                                    </defs>
                                </svg>
                            </div>

                            <p className="textPrimaryModalFilterManager" >{t('justification')}</p>
                        </div>

                        <button className="textBtnFilterManagerModal" style={btnStyleModal} onClick={() => storage()}>
                            Salvar
                        </button>


                    </Modal.Header>
                    <Modal.Body>

                        {list.map((item, index) => {
                            return (

                                <InputFilterManager
                                    value={item.reason}
                                    name={t('fieldName')}
                                    onChange={(e) => setNewName(e.target.value)}
                                    type="text"
                                    onBlur={(e) => setItemsData(e.target.value)}
                                    remove={() => removeItem(item, item.reason)}
                                    count={item.idCountage} index={index + 1} />

                            )

                        })}




                    </Modal.Body>

                    <Modal.Footer style={{ border: "none" }}>

                        <div style={{ width: "100%", display: "flex", justifyContent: "space-between", height: "20px" }}>
                            <p className="textReasonFilterManager" onClick={() => setItems()}>{t('addNewReason')}</p>
                            <div></div>
                        </div>
                    </Modal.Footer>

                </Modal>


                <Modal
                    dialogClassName="modal-filter-upload"
                    show={showModalUpload}
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                >
                    <Modal.Header >

                        <div style={{ display: "flex", height: "30px" }}>
                            <div onClick={() => setShowModalUpload(false)} style={{ cursor: "pointer" }}>
                                <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g clip-path="url(#clip0_0_2887)">
                                        <path d="M7.49864 6.3679L12.5016 1.35941C12.8122 1.04847 12.8122 0.544354 12.5016 0.233445C12.1911 -0.0774893 11.6876 -0.0774893 11.377 0.233445L6.37456 5.24246L1.37211 0.233445C1.06155 -0.0774893 0.55804 -0.0774893 0.247506 0.233445C-0.0630274 0.544378 -0.0630522 1.0485 0.247506 1.35941L5.25048 6.3679L0.247506 11.3764C-0.0630522 11.6874 -0.0630522 12.1915 0.247506 12.5024C0.558065 12.8133 1.06158 12.8133 1.37211 12.5024L6.37456 7.49334L11.377 12.5024C11.6876 12.8133 12.1911 12.8133 12.5016 12.5024C12.8122 12.1915 12.8122 11.6873 12.5016 11.3764L7.49864 6.3679Z" fill="black" />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_0_2887">
                                            <rect width="12.72" height="12.7354" fill="white" transform="translate(0.0143433)" />
                                        </clipPath>
                                    </defs>
                                </svg>
                            </div>

                            <p className="textPrimaryModalFilterManager">{t('uploadStock')}</p>
                        </div>

                        <button className="textBtnFilterManagerModal" style={btnStyleModal} onClick={() => storageTest()}>{t('add')}</button>


                    </Modal.Header>
                    <Modal.Body>

                        <div style={{ position: "relative" }}>
                            <InputSelectFilterManager onChange={(e) => setClient(e.target.value)} type="client" name={t('client')} top="43px" />
                            {clientError != undefined

                                ?
                                <p className="errorMessage">{clientError}</p>

                                :
                                <></>
                            }
                        </div>

                        <div style={{ position: "relative" }}>
                            <InputSelectFilterManager onChange={(e) => setTypeCountage(e.target.value)} type="typeCountage" name={t('countType')} top="40px" />
                            {typeCountageError != undefined

                                ?
                                <p className="errorMessage">{typeCountageError}</p>

                                :
                                <></>
                            }

                        </div>

                        <div style={{ marginBottom: "25px" }}>
                            <p className='textLabelInputSelectFilterManager'>{t('numberOfLines')}</p>

                            <div style={{ width: "100px", height: "45px", border: "1px solid #d7d7d7", borderRadius: "8px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                <p style={{ marginBottom: 0 }} className='textPrimaryLabelInput'>{numberLine}</p>
                            </div>
                        </div>

                        <div style={{ width: "100%", height: "280px", border: "1px solid #D7D7D7", borderRadius: "10px" }}>


                            <input type="file" id="file" onChange={(e) => handleFile(e.target.files[0])} accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" name="file" style={{ display: "none" }} />
                            <label htmlFor='file' style={{ display: "flex", justifyContent: "center" }}>
                                <div style={{ display: "flex", justifyContent: "center", marginTop: "23px" }}>
                                    <svg width="275" height="49" viewBox="0 0 275 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="1" y="1" width="273" height="47" rx="23.5" fill="white" />
                                        <path d="M81.008 17.88V24.968C81.008 25.8107 81.2267 26.4453 81.664 26.872C82.112 27.2987 82.7307 27.512 83.52 27.512C84.32 27.512 84.9387 27.2987 85.376 26.872C85.824 26.4453 86.048 25.8107 86.048 24.968V17.88H87.872V24.936C87.872 25.8427 87.6747 26.6107 87.28 27.24C86.8853 27.8693 86.3573 28.3387 85.696 28.648C85.0347 28.9573 84.304 29.112 83.504 29.112C82.704 29.112 81.9733 28.9573 81.312 28.648C80.6613 28.3387 80.144 27.8693 79.76 27.24C79.376 26.6107 79.184 25.8427 79.184 24.936V17.88H81.008ZM92.0709 21.48C92.3802 21.0747 92.8015 20.7333 93.3349 20.456C93.8682 20.1787 94.4709 20.04 95.1429 20.04C95.9109 20.04 96.6095 20.232 97.2389 20.616C97.8789 20.9893 98.3802 21.5173 98.7429 22.2C99.1055 22.8827 99.2869 23.6667 99.2869 24.552C99.2869 25.4373 99.1055 26.232 98.7429 26.936C98.3802 27.6293 97.8789 28.1733 97.2389 28.568C96.6095 28.952 95.9109 29.144 95.1429 29.144C94.4709 29.144 93.8735 29.0107 93.3509 28.744C92.8282 28.4667 92.4015 28.1253 92.0709 27.72V33.192H90.2469V20.184H92.0709V21.48ZM97.4309 24.552C97.4309 23.944 97.3029 23.4213 97.0469 22.984C96.8015 22.536 96.4709 22.2 96.0549 21.976C95.6495 21.7413 95.2122 21.624 94.7429 21.624C94.2842 21.624 93.8469 21.7413 93.4309 21.976C93.0255 22.2107 92.6949 22.552 92.4389 23C92.1935 23.448 92.0709 23.976 92.0709 24.584C92.0709 25.192 92.1935 25.7253 92.4389 26.184C92.6949 26.632 93.0255 26.9733 93.4309 27.208C93.8469 27.4427 94.2842 27.56 94.7429 27.56C95.2122 27.56 95.6495 27.4427 96.0549 27.208C96.4709 26.9627 96.8015 26.6107 97.0469 26.152C97.3029 25.6933 97.4309 25.16 97.4309 24.552ZM102.915 17.16V29H101.091V17.16H102.915ZM109.133 29.144C108.301 29.144 107.549 28.9573 106.877 28.584C106.205 28.2 105.677 27.6667 105.293 26.984C104.909 26.2907 104.717 25.4907 104.717 24.584C104.717 23.688 104.915 22.8933 105.309 22.2C105.704 21.5067 106.243 20.9733 106.925 20.6C107.608 20.2267 108.371 20.04 109.213 20.04C110.056 20.04 110.819 20.2267 111.501 20.6C112.184 20.9733 112.723 21.5067 113.117 22.2C113.512 22.8933 113.709 23.688 113.709 24.584C113.709 25.48 113.507 26.2747 113.101 26.968C112.696 27.6613 112.141 28.2 111.437 28.584C110.744 28.9573 109.976 29.144 109.133 29.144ZM109.133 27.56C109.603 27.56 110.04 27.448 110.445 27.224C110.861 27 111.197 26.664 111.453 26.216C111.709 25.768 111.837 25.224 111.837 24.584C111.837 23.944 111.715 23.4053 111.469 22.968C111.224 22.52 110.899 22.184 110.493 21.96C110.088 21.736 109.651 21.624 109.181 21.624C108.712 21.624 108.275 21.736 107.869 21.96C107.475 22.184 107.16 22.52 106.925 22.968C106.691 23.4053 106.573 23.944 106.573 24.584C106.573 25.5333 106.813 26.2693 107.293 26.792C107.784 27.304 108.397 27.56 109.133 27.56ZM114.905 24.552C114.905 23.6667 115.086 22.8827 115.449 22.2C115.822 21.5173 116.323 20.9893 116.953 20.616C117.593 20.232 118.297 20.04 119.065 20.04C119.758 20.04 120.361 20.1787 120.873 20.456C121.395 20.7227 121.811 21.0587 122.121 21.464V20.184H123.961V29H122.121V27.688C121.811 28.104 121.39 28.4507 120.857 28.728C120.323 29.0053 119.715 29.144 119.033 29.144C118.275 29.144 117.582 28.952 116.953 28.568C116.323 28.1733 115.822 27.6293 115.449 26.936C115.086 26.232 114.905 25.4373 114.905 24.552ZM122.121 24.584C122.121 23.976 121.993 23.448 121.737 23C121.491 22.552 121.166 22.2107 120.761 21.976C120.355 21.7413 119.918 21.624 119.449 21.624C118.979 21.624 118.542 21.7413 118.137 21.976C117.731 22.2 117.401 22.536 117.145 22.984C116.899 23.4213 116.777 23.944 116.777 24.552C116.777 25.16 116.899 25.6933 117.145 26.152C117.401 26.6107 117.731 26.9627 118.137 27.208C118.553 27.4427 118.99 27.56 119.449 27.56C119.918 27.56 120.355 27.4427 120.761 27.208C121.166 26.9733 121.491 26.632 121.737 26.184C121.993 25.7253 122.121 25.192 122.121 24.584ZM125.748 24.552C125.748 23.6667 125.93 22.8827 126.292 22.2C126.666 21.5173 127.167 20.9893 127.796 20.616C128.436 20.232 129.146 20.04 129.924 20.04C130.5 20.04 131.066 20.168 131.62 20.424C132.186 20.6693 132.634 21 132.964 21.416V17.16H134.804V29H132.964V27.672C132.666 28.0987 132.25 28.4507 131.716 28.728C131.194 29.0053 130.591 29.144 129.908 29.144C129.14 29.144 128.436 28.952 127.796 28.568C127.167 28.1733 126.666 27.6293 126.292 26.936C125.93 26.232 125.748 25.4373 125.748 24.552ZM132.964 24.584C132.964 23.976 132.836 23.448 132.58 23C132.335 22.552 132.01 22.2107 131.604 21.976C131.199 21.7413 130.762 21.624 130.292 21.624C129.823 21.624 129.386 21.7413 128.98 21.976C128.575 22.2 128.244 22.536 127.988 22.984C127.743 23.4213 127.62 23.944 127.62 24.552C127.62 25.16 127.743 25.6933 127.988 26.152C128.244 26.6107 128.575 26.9627 128.98 27.208C129.396 27.4427 129.834 27.56 130.292 27.56C130.762 27.56 131.199 27.4427 131.604 27.208C132.01 26.9733 132.335 26.632 132.58 26.184C132.836 25.7253 132.964 25.192 132.964 24.584ZM140.748 24.552C140.748 23.6667 140.93 22.8827 141.292 22.2C141.666 21.5173 142.167 20.9893 142.796 20.616C143.436 20.232 144.146 20.04 144.924 20.04C145.5 20.04 146.066 20.168 146.62 20.424C147.186 20.6693 147.634 21 147.964 21.416V17.16H149.804V29H147.964V27.672C147.666 28.0987 147.25 28.4507 146.716 28.728C146.194 29.0053 145.591 29.144 144.908 29.144C144.14 29.144 143.436 28.952 142.796 28.568C142.167 28.1733 141.666 27.6293 141.292 26.936C140.93 26.232 140.748 25.4373 140.748 24.552ZM147.964 24.584C147.964 23.976 147.836 23.448 147.58 23C147.335 22.552 147.01 22.2107 146.604 21.976C146.199 21.7413 145.762 21.624 145.292 21.624C144.823 21.624 144.386 21.7413 143.98 21.976C143.575 22.2 143.244 22.536 142.988 22.984C142.743 23.4213 142.62 23.944 142.62 24.552C142.62 25.16 142.743 25.6933 142.988 26.152C143.244 26.6107 143.575 26.9627 143.98 27.208C144.396 27.4427 144.834 27.56 145.292 27.56C145.762 27.56 146.199 27.4427 146.604 27.208C147.01 26.9733 147.335 26.632 147.58 26.184C147.836 25.7253 147.964 25.192 147.964 24.584ZM156.024 29.144C155.192 29.144 154.44 28.9573 153.768 28.584C153.096 28.2 152.568 27.6667 152.184 26.984C151.8 26.2907 151.608 25.4907 151.608 24.584C151.608 23.688 151.805 22.8933 152.2 22.2C152.595 21.5067 153.133 20.9733 153.816 20.6C154.499 20.2267 155.261 20.04 156.104 20.04C156.947 20.04 157.709 20.2267 158.392 20.6C159.075 20.9733 159.613 21.5067 160.008 22.2C160.403 22.8933 160.6 23.688 160.6 24.584C160.6 25.48 160.397 26.2747 159.992 26.968C159.587 27.6613 159.032 28.2 158.328 28.584C157.635 28.9573 156.867 29.144 156.024 29.144ZM156.024 27.56C156.493 27.56 156.931 27.448 157.336 27.224C157.752 27 158.088 26.664 158.344 26.216C158.6 25.768 158.728 25.224 158.728 24.584C158.728 23.944 158.605 23.4053 158.36 22.968C158.115 22.52 157.789 22.184 157.384 21.96C156.979 21.736 156.541 21.624 156.072 21.624C155.603 21.624 155.165 21.736 154.76 21.96C154.365 22.184 154.051 22.52 153.816 22.968C153.581 23.4053 153.464 23.944 153.464 24.584C153.464 25.5333 153.704 26.2693 154.184 26.792C154.675 27.304 155.288 27.56 156.024 27.56ZM174.639 24.376C174.639 24.7067 174.618 25.0053 174.575 25.272H167.839C167.893 25.976 168.154 26.5413 168.623 26.968C169.093 27.3947 169.669 27.608 170.351 27.608C171.333 27.608 172.026 27.1973 172.431 26.376H174.399C174.133 27.1867 173.647 27.8533 172.943 28.376C172.25 28.888 171.386 29.144 170.351 29.144C169.509 29.144 168.751 28.9573 168.079 28.584C167.418 28.2 166.895 27.6667 166.511 26.984C166.138 26.2907 165.951 25.4907 165.951 24.584C165.951 23.6773 166.133 22.8827 166.495 22.2C166.869 21.5067 167.386 20.9733 168.047 20.6C168.719 20.2267 169.487 20.04 170.351 20.04C171.183 20.04 171.925 20.2213 172.575 20.584C173.226 20.9467 173.733 21.4587 174.095 22.12C174.458 22.7707 174.639 23.5227 174.639 24.376ZM172.735 23.8C172.725 23.128 172.485 22.5893 172.015 22.184C171.546 21.7787 170.965 21.576 170.271 21.576C169.642 21.576 169.103 21.7787 168.655 22.184C168.207 22.5787 167.941 23.1173 167.855 23.8H172.735ZM180.21 24.536L183.058 29H180.994L179.09 26.008L177.298 29H175.394L178.242 24.664L175.394 20.184H177.458L179.362 23.176L181.154 20.184H183.058L180.21 24.536ZM183.811 24.584C183.811 23.6773 183.992 22.8827 184.355 22.2C184.728 21.5067 185.24 20.9733 185.891 20.6C186.541 20.2267 187.288 20.04 188.131 20.04C189.197 20.04 190.077 20.296 190.771 20.808C191.475 21.3093 191.949 22.0293 192.195 22.968H190.227C190.067 22.5307 189.811 22.1893 189.459 21.944C189.107 21.6987 188.664 21.576 188.131 21.576C187.384 21.576 186.787 21.8427 186.339 22.376C185.901 22.8987 185.683 23.6347 185.683 24.584C185.683 25.5333 185.901 26.2747 186.339 26.808C186.787 27.3413 187.384 27.608 188.131 27.608C189.187 27.608 189.885 27.144 190.227 26.216H192.195C191.939 27.112 191.459 27.8267 190.755 28.36C190.051 28.8827 189.176 29.144 188.131 29.144C187.288 29.144 186.541 28.9573 185.891 28.584C185.24 28.2 184.728 27.6667 184.355 26.984C183.992 26.2907 183.811 25.4907 183.811 24.584ZM202.093 24.376C202.093 24.7067 202.071 25.0053 202.029 25.272H195.293C195.346 25.976 195.607 26.5413 196.077 26.968C196.546 27.3947 197.122 27.608 197.805 27.608C198.786 27.608 199.479 27.1973 199.885 26.376H201.852C201.586 27.1867 201.101 27.8533 200.397 28.376C199.703 28.888 198.839 29.144 197.805 29.144C196.962 29.144 196.205 28.9573 195.533 28.584C194.871 28.2 194.349 27.6667 193.965 26.984C193.591 26.2907 193.405 25.4907 193.405 24.584C193.405 23.6773 193.586 22.8827 193.949 22.2C194.322 21.5067 194.839 20.9733 195.501 20.6C196.173 20.2267 196.941 20.04 197.805 20.04C198.637 20.04 199.378 20.2213 200.029 20.584C200.679 20.9467 201.186 21.4587 201.549 22.12C201.911 22.7707 202.093 23.5227 202.093 24.376ZM200.189 23.8C200.178 23.128 199.938 22.5893 199.469 22.184C198.999 21.7787 198.418 21.576 197.725 21.576C197.095 21.576 196.557 21.7787 196.109 22.184C195.661 22.5787 195.394 23.1173 195.309 23.8H200.189ZM205.712 17.16V29H203.888V17.16H205.712Z" fill="black" />
                                        <g clip-path="url(#clip0_0_2638)">
                                            <path d="M44.1149 18.4916C43.9265 18.4379 43.7545 18.3378 43.6146 18.2007C43.4747 18.0635 43.3713 17.8935 43.3139 17.7062C42.9949 16.625 42.4599 15.6197 41.7412 14.7513C41.0225 13.8828 40.135 13.1692 39.1326 12.6536C38.1301 12.1381 37.0334 11.8312 35.909 11.7517C34.7845 11.6722 33.6556 11.8217 32.5906 12.191C31.5255 12.5604 30.5465 13.142 29.7127 13.9007C28.879 14.6594 28.2078 15.5793 27.7398 16.6049C27.2718 17.6304 27.0168 18.7403 26.9902 19.8672C26.9635 20.9942 27.1658 22.1149 27.5847 23.1614C27.681 23.3816 27.7017 23.6275 27.6437 23.8608C27.5856 24.094 27.4521 24.3015 27.2639 24.451C26.4345 25.0666 25.7869 25.895 25.3897 26.8485C24.9925 27.8021 24.8605 28.8452 25.0077 29.8676C25.2373 31.2498 25.9549 32.5038 27.0301 33.4021C28.1054 34.3004 29.4671 34.7834 30.8681 34.7635H36.4066C36.6829 34.7635 36.9478 34.6537 37.1432 34.4584C37.3385 34.263 37.4483 33.9981 37.4483 33.7218C37.4483 33.4455 37.3385 33.1806 37.1432 32.9852C36.9478 32.7899 36.6829 32.6801 36.4066 32.6801H30.8681C29.9684 32.702 29.0906 32.4008 28.3939 31.8311C27.6971 31.2614 27.2275 30.461 27.0702 29.5749C26.9704 28.9236 27.0512 28.2574 27.304 27.6489C27.5567 27.0403 27.9716 26.5129 28.5035 26.1239C29.0622 25.7064 29.4663 25.115 29.6524 24.4429C29.8385 23.7707 29.796 23.0558 29.5316 22.4103C29.0089 21.0298 28.982 19.5106 29.4556 18.1124C29.8339 17.0172 30.5114 16.0498 31.4113 15.3198C32.3112 14.5899 33.3975 14.1265 34.5472 13.9822C34.8139 13.9479 35.0825 13.9305 35.3514 13.9301C36.6983 13.9257 38.0105 14.3577 39.0913 15.1614C40.1722 15.9651 40.9637 17.0973 41.3472 18.3885C41.497 18.8805 41.7667 19.3276 42.1322 19.6895C42.4977 20.0513 42.9475 20.3166 43.441 20.4614C44.6488 20.8186 45.7187 21.5363 46.5073 22.5183C47.296 23.5003 47.7659 24.6998 47.854 25.9563C47.9422 27.2127 47.6444 28.4661 47.0005 29.5486C46.3567 30.6311 45.3975 31.4911 44.2514 32.0135C44.0818 32.1003 43.94 32.2331 43.8422 32.3966C43.7444 32.5602 43.6945 32.7479 43.6983 32.9385C43.6962 33.1108 43.7375 33.281 43.8184 33.4332C43.8992 33.5855 44.017 33.715 44.1609 33.8098C44.3048 33.9047 44.4703 33.9619 44.6421 33.9762C44.8139 33.9905 44.9865 33.9614 45.1441 33.8916C49.4504 31.8218 51.7899 26.377 48.1441 21.1166C47.1402 19.8071 45.7184 18.8808 44.1149 18.4916Z" fill="#123164" />
                                            <path d="M44.4352 28.2084C44.6305 28.0131 44.7402 27.7482 44.7402 27.472C44.7402 27.1957 44.6305 26.9308 44.4352 26.7355L42.7832 25.0834C42.1971 24.4976 41.4024 24.1685 40.5738 24.1685C39.7451 24.1685 38.9504 24.4976 38.3644 25.0834L36.7123 26.7355C36.5226 26.932 36.4176 27.1951 36.42 27.4682C36.4223 27.7413 36.5319 28.0026 36.725 28.1957C36.9182 28.3889 37.1794 28.4984 37.4525 28.5008C37.7257 28.5032 37.9888 28.3982 38.1852 28.2084L39.5321 26.8615V34.7636C39.5321 35.0399 39.6419 35.3048 39.8372 35.5002C40.0326 35.6955 40.2975 35.8053 40.5738 35.8053C40.85 35.8053 41.115 35.6955 41.3103 35.5002C41.5057 35.3048 41.6154 35.0399 41.6154 34.7636V26.8615L42.9623 28.2084C43.1577 28.4037 43.4226 28.5134 43.6988 28.5134C43.975 28.5134 44.2399 28.4037 44.4352 28.2084Z" fill="#123164" />
                                        </g>
                                        <rect x="1" y="1" width="273" height="47" rx="23.5" stroke="#D7D7D7" stroke-width="2" stroke-dasharray="5 5" />
                                        <defs>
                                            <clipPath id="clip0_0_2638">
                                                <rect width="25" height="25" fill="white" transform="translate(24.9492 10.8052)" />
                                            </clipPath>
                                        </defs>
                                    </svg>
                                </div>
                            </label>

                            <div style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                marginTop: "30px",
                                flexDirection: "column",
                            }}>

                                {
                                    fileCvg && (
                                        <>
                                            <div style={{
                                                position: "relative",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                flexDirection: "column"
                                            }}>
                                                <div style={{ position: "relative" }}>
                                                    <img src={closeIcon} onClick={() => {
                                                        setStock();
                                                        setFileCvg();
                                                        setNumberLine(0)
                                                    }} style={{ position: "absolute", top: "-10px", right: "-8px", cursor: "pointer" }} />
                                                    <img src={fileIcon} />
                                                </div>
                                                <p className='textFileCvg'>{fileCvg.name}</p>
                                            </div>
                                        </>
                                    )

                                }

                            </div>

                        </div>

                    </Modal.Body>

                </Modal>



            </div>


        </div>

    )

}

export default FilterManager